import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

/**
 * Fonte única da verdade: indica se o usuário autenticado é um candidato
 * em uma contratação ativa. Confia exclusivamente na RPC `is_candidato_ativo`
 * (SECURITY DEFINER) — sem heurísticas por role/permissão.
 */
export function useIsCandidatoContratacao() {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ['is-candidato-ativo', user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_candidato_ativo' as any, {
        uid: user!.id,
      });
      if (error) throw error;
      return Boolean(data);
    },
  });

  return {
    isCandidato: query.data === true,
    isLoading: query.isLoading,
    error: query.error,
  };
}
